var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKabelErzeugungsanlagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 118,
    viewBox: "0 0 277 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.949 115.486L205.688 75.4802L270.469 39.5509L205.688 2.53296L60.7622 85.6726L3.04349 56.4068",
    stroke: "#b4005f",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabelErzeugungsanlagen);
export default __webpack_public_path__ + "static/media/Kabel-Erzeugungsanlagen.a2f9662b5e449ebc9b535e70f116c1c0.svg";
export { ForwardRef as ReactComponent };